import React, { FC } from 'react';

import styles from './project-logo-placeholder.module.sass';

export const ProjectLogoPlaceholder : FC = () => {
  return <i className={`fas fa-dice-d6 ${styles.projectLogoPlaceHolder}`}/>
}
